/*eslint-disable */
import React from "react";
import { Box, Button, Card, FormControlLabel, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

const GPTDataTable = ({ titleData, handleTitleSelect, selectedTitleInfo, showGPTTable, handleGenerateClick }) => {
  const theme = useTheme();
  const customizer = useSelector(state => state.customizer);

  return (
    <Card
      sx={{
        padding: { xs: "15px 15px 50px 15px", sm: "30px 30px 24px 30px" },
        border: `1px solid ${theme.palette.divider}`,
      }}
      elevation={customizer.isCardShadow ? 9 : 0}
      variant={!customizer.isCardShadow ? "outlined" : undefined}
    >
      <Typography component="h2" className="TableMainHeading">
        Title Data
      </Typography>
      <TableContainer>
        <Table className="KewordTable">
          <TableHead className="selectTitleTableHead">
            <TableRow>
              <TableCell>Titles</TableCell>
              <TableCell>Keywords</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!showGPTTable
              ? titleData?.gptTitleData.map((title, index) => {
                  const titleWithoutKeyword = title.split(" : ")[0];
                  const focusKeyword = title.split(" : ")[1];
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <RadioGroup value={selectedTitleInfo?.title} onChange={event => handleTitleSelect(event, "gptTitleData")}>
                          <FormControlLabel
                            value={titleWithoutKeyword?.replace(/\\/g, "").replace(/^\d+\.\s/, "")}
                            control={<Radio />}
                            label={titleWithoutKeyword?.replace(/\\/g, "").replace(/^\d+\.\s/, "")}
                          />
                        </RadioGroup>
                      </TableCell>
                      <TableCell>{focusKeyword}</TableCell>
                    </TableRow>
                  );
                })
              : Array.isArray(titleData) &&
                titleData?.map((title, index) => {
                  const titleWithoutKeyword = title.split(" : ")[0];
                  const focusKeyword = title.split(" : ")[1];
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <RadioGroup value={selectedTitleInfo?.title} onChange={handleTitleSelect}>
                          <FormControlLabel
                            value={titleWithoutKeyword?.replace(/\\/g, "").replace(/^\d+\.\s/, "")}
                            control={<Radio />}
                            label={titleWithoutKeyword.replace(/\\/g, "").replace(/^\d+\.\s/, "")}
                            sx={{ m: "0" }}
                          />
                        </RadioGroup>
                      </TableCell>
                      <TableCell>{focusKeyword}</TableCell>
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
        {showGPTTable && (
          <Box className="FooterBtnWrapper">
            <Button className="generateBlogBtn" onClick={() => handleGenerateClick("GPT")} disabled={!selectedTitleInfo.title}>
              Generate blog
            </Button>
            {/* <Button className="generateBlogBtn" onClick={() => handleGenerateClick("Both")} disabled={!selectedTitleInfo.title}>
            Generate Blog For Both
          </Button>
          <Button className="generateBlogBtn" onClick={() => handleGenerateClick("Gemini")} disabled={!selectedTitleInfo.title}>
            Generate Blog By Gemini
          </Button> */}
          </Box>
        )}
      </TableContainer>
    </Card>
  );
};

export default GPTDataTable;
